import { useEffect } from 'react';
import { onIframeMount, onIframeUnmount } from 'utils';

const useIframeFunctions = ({
    parentRoute,
    styles,
    title
}: {
    parentRoute?: string;
    styles?: { [key: string]: string };
    title?: string;
}): void => {
    useEffect(() => {
        onIframeMount({ parentRoute, styles, title });
        return (): void => {
            onIframeUnmount();
        };
    }, [parentRoute, styles]);
};

export default useIframeFunctions;
